module.exports = __webpack_public_path__ + "img/check-solid.c15fb90c.svg";